export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_API_BASE_URL,
}
